/** Формат КМ */
export enum MarkingCodeType {
	/** Неизвестный код товара */
	UnknownProductCode = "UNKNOWN_PRODUCT_CODE",
	/** Значение кода маркировки в формате EAN-8 */
	Ean8 = "EAN8",
	/** Значение кода маркировки в формате EAN-13 */
	Ean13 = "EAN13",
	/** Значение кода маркировки в формате ITF-14 */
	Itf14 = "ITF14",
	/** Значение кода маркировки в формате GS1 */
	Gs1 = "GS1",
	/** Значение кода маркировки в формате GS1.M */
	Gs1m = "GS1M",
	/** Значение кода маркировки в формате КМК (Короткий код маркировки) */
	ShortMc = "SHORT_MC",
	/** Контрольно-идентификационный знак мехового изделия */
	Fur = "FUR",
	/** Значение кода маркировки в формате ЕГАИС-2.0 */
	Egais20 = "EGAIS20",
	/** Значение кода маркировки в формате ЕГАИС-3.0 */
	Egais30 = "EGAIS30",
	/** Определяется ФНС России */
	Ktf1 = "KTF1",
	/** Определяется ФНС России */
	Ktf2 = "KTF2",
	/** Определяется ФНС России */
	Ktf3 = "KTF3",
	/** Определяется ФНС России */
	Ktf4 = "KTF4",
	/** Определяется ФНС России */
	Ktf5 = "KTF5",
	/** Определяется ФНС России */
	Ktf6 = "KTF6",
}
